import { exportTranslateStaticLoader } from './common-theme/i18n/translate-browser-loader.service';
const ɵ0 = exportTranslateStaticLoader;
export class AppModule {
}
export { ɵ0 };
